import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { setAssociationFilter } from 'bundles/research/index/store/actions/query';

import FilterCheckboxGroup from 'components/search_sidebar/filter_checkbox_group';
import FilterButton from 'components/ui/filter_button';
import ManagedInput from 'components/form/managed_input';
import ResearchAddressFilterGroup from 'bundles/research/index/filters/research_address_filter_group';
import ResearchPropertyFilterGroup from 'bundles/research/index/filters/research_property_filter_group';
import { isPresent } from 'helpers/string_helpers';
import { filterLabelMappings } from 'bundles/research/index/research_constants';

export class ResearchFilters extends React.Component {
  static propTypes = {
    associationFilters: PropTypes.object.isRequired,
    availabilities: PropTypes.array.isRequired,
    features: PropTypes.object.isRequired,
    industrialFilter: PropTypes.object,
    multifamilyFilter: PropTypes.object,
    propertyFilter: PropTypes.object.isRequired,
    selectedAssetClasses: PropTypes.array.isRequired,
    selectedAvailabilities: PropTypes.array.isRequired,
    selectedBuildingClasses: PropTypes.array.isRequired,
    selectedInvestmentTypes: PropTypes.array.isRequired,
    setAssociationFilter: PropTypes.func.isRequired,

    onAvailabilityChange: PropTypes.func.isRequired,
  };

  static defaultProps = {
    industrialFilter: {},
  };

  render() {
    return (
      <React.Fragment>
        {this.renderPropertyButton()}
        {this.renderAvailabilitiesButton()}
        <ResearchAddressFilterGroup />
        {this.renderAssociationsFilter()}
      </React.Fragment>
    );
  }

  renderAvailabilitiesButton() {
    const { availabilities, selectedAvailabilities, onAvailabilityChange } =
      this.props;

    return (
      <FilterButton
        filtersApplied={selectedAvailabilities.length > 0}
        label="Availability"
        name="availabilities"
      >
        <FilterCheckboxGroup
          options={availabilities}
          selected={selectedAvailabilities}
          onChange={onAvailabilityChange}
        />
      </FilterButton>
    );
  }

  renderPropertyButton() {
    const {
      industrialFilter,
      multifamilyFilter,
      propertyFilter,
      selectedAssetClasses,
      selectedBuildingClasses,
      selectedInvestmentTypes,
    } = this.props;

    const propertyFiltersApplied = Object.keys(propertyFilter).some((key) => {
      if (key === 'lotUnits') return false;
      return isPresent(propertyFilter[key]);
    });

    const multifamilyFiltersApplied = Object.keys(multifamilyFilter).some(
      key => isPresent(multifamilyFilter[key])
    );

    const booleanFilters = ['driveThroughAccess', 'ready', 'served'];

    const industrialFiltersApplied = Object.keys(industrialFilter).some(
      (key) => {
        if (booleanFilters.includes(key)) return industrialFilter[key] === true;
        return isPresent(industrialFilter[key]);
      }
    );

    const filtersApplied =
      propertyFiltersApplied ||
      industrialFiltersApplied ||
      multifamilyFiltersApplied ||
      selectedBuildingClasses.length > 0 ||
      selectedAssetClasses.length > 0 ||
      selectedInvestmentTypes.length > 0;
    return (
      <FilterButton
        filtersApplied={filtersApplied}
        label="Property & Building"
        name="property-filters-popover"
        popoverBodyClassName="overflow-y-auto"
      >
        <ResearchPropertyFilterGroup />
      </FilterButton>
    );
  }

  renderAssociationsFilter() {
    if (!this.props.features.edgeCrm || (!this.props.features.marketingListings && !this.props.features.apex)) {
      return null;
    }

    const filters = [];

    if (this.props.features.marketingListings) {
      filters.unshift('hasActiveEdgeProjects');
    }

    if (this.props.features.apex) {
      filters.unshift('hasActiveDeals');
    }

    return (
      <FilterButton
        filtersApplied={Object.values(this.props.associationFilters).some(
          value => value
        )}
        label="View"
        name="associations"
      >
        {filters.map(key => (
          <ManagedInput
            checked={this.props.associationFilters[key]}
            key={key}
            label={filterLabelMappings[key]}
            name={key}
            type="checkbox"
            onValueChange={value => this.props.setAssociationFilter(key, value)
            }
          />
        ))}
      </FilterButton>
    );
  }
}

const mapStateToProps = state => ({
  associationFilters: state.query.associationFilters,
  query: state.query,
  features: state.features,
});

const mapDispatchToProps = {
  setAssociationFilter,
};

export default connect(mapStateToProps, mapDispatchToProps)(ResearchFilters);
